import { GspDataTransferObject } from './entity/define/gsp-dto';

export class GspDtoMetadata extends GspDataTransferObject{
    
}